import Button from "components/shared/button/Button";
import CircularProgress from "components/shared/circular-progress/CircularProgress";
import { useContext, useEffect, useState } from "react";
import GuiContext from "../../config/context/guiContext";
import PluginsContext from "../../config/context/pluginsContext";
import ToastContext from "../../config/context/toastContext";
import styles from "../../css/plugins.module.css";
import { pluginManager } from "../../lib/pluginManager";
import ToastList from "../toast/ToastList";
import { useClearAuthKeys } from "api/authentication/usePrivateKey";

function PluginsBuiltIn({ items2, userPlugins, refreshData }) {
  const {
    URL,
    userData: { guiname, id: accountId },
    selected: { selectedServer, selectedAccount },
  } = useContext(GuiContext);
  const [userPlgState, setUserPlgState] = useState(userPlugins);
  const [loadingStates, setLoadingStates] = useState({});
  const { updatePluginsContext } = useContext(PluginsContext);
  const { insertIntoToastList, emptyToastList } = useContext(ToastContext);
  const { clearAuthKeys } = useClearAuthKeys();

  useEffect(() => {
    setUserPlgState(userPlugins);
  }, [userPlugins]);

  const renderedItems = items2?.map((item, id) => {
    const userPlg = userPlgState?.find((obj) => obj.id === item.id);
    let isLoading = loadingStates[item.id] || false;
    const handleApplyPlugin = async () => {
      emptyToastList();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: true,
      }));
      let pluginSwitchRes = await pluginManager(
        true,
        item.id,
        URL,
        selectedServer,
        guiname,
        accountId,
        insertIntoToastList,
      );
      updatePluginsContext(pluginSwitchRes);
      await refreshData();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: false,
      }));
    };

    const handleDisablePlugin = async () => {
      emptyToastList();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: true,
      }));
      let pluginSwitchRes = await pluginManager(
        false,
        item.id,
        URL,
        selectedServer,
        guiname,
        accountId,
        insertIntoToastList,
      );
      updatePluginsContext(pluginSwitchRes);
      if (item?.id === 7) {
        clearAuthKeys();
      }
      await refreshData();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: false,
      }));
    };

    return (
      <div key={item.id} className={styles.tabItemBuiltIn}>
        <div>
          <h2>{item.plugin_name.substring(0, 3)}</h2>
        </div>
        <div>
          <h3>{item.plugin_name}</h3>
          <p>{item.plugin_desc}</p>
        </div>
        <div className={`${styles.buttonWrapper}`}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <>
              {!userPlg?.active ? (
                <button className={styles.apply_btn} onClick={handleApplyPlugin}>
                  Apply
                </button>
              ) : (
                <button className={styles.disable_btn} onClick={handleDisablePlugin}>
                  Disable
                </button>
              )}
            </>
          )}
        </div>
        <ToastList />
      </div>
    );
  });

  return <div className={styles.tabWrapper}>{renderedItems}</div>;
}

export default PluginsBuiltIn;
